import { useRef, useState, useEffect } from 'react';
import fixWebmDuration from 'fix-webm-duration';

const useAudioRecorder = () => {
  const mediaRecorder = useRef(null);
  const [isRecording, setIsRecording] = useState(false);
  const [chunks, setChunks] = useState([]);
  const [audio, setAudio] = useState(null);
  const [stream, setStream] = useState(null);
  const [duration, setDuration] = useState(0);
  const [startTimestamp, setStartTimestamp] = useState(null);

  const recordAudio = async () => {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    setStream(stream);

    mediaRecorder.current = new MediaRecorder(stream, {
      mimeType: 'audio/mp4',
    });
    let audioChunks = [];

    mediaRecorder.current.ondataavailable = (event) => {
      if (typeof event.data === 'undefined' || event.data.size === 0) return;
      audioChunks.push(event.data);
    };
    setChunks(audioChunks);

    mediaRecorder.current.start();
    setIsRecording(true);
  };

  const stopRecording = () => {
    if (mediaRecorder.current) {
      mediaRecorder.current.onstop = async () => {
        //creates a blob file from the audiochunks data
        const audioBlob = new Blob(chunks, { type: 'audio/mp4' });

        // const fixedDurationAudio = await fixWebmDuration(
        //   audioBlob,
        //   Date.now() - startTimestamp,
        //   {
        //     logger: false,
        //   }
        // );

        setChunks([]);
        setDuration(0);
        setAudio({
          data: audioBlob,
          // url: URL.createObjectURL(fixedDurationAudio), //creates a playable URL from the blob file.
        });
      };

      mediaRecorder.current.stop();
      stream.getTracks()[0].stop();
    }
    setIsRecording(false);
  };

  const clearRecording = () => {
    setChunks([]);
    setDuration(0);
    setAudio(null);
    setIsRecording(false);
  };

  useEffect(() => {
    if (!isRecording) return;

    const timer = setInterval(() => {
      setDuration((prevDuration) => prevDuration + 1);
    }, 1000);

    setStartTimestamp(Date.now());

    return () => {
      clearInterval(timer);
      if (isRecording && stream) stream.getTracks()[0].stop();
    };
  }, [isRecording]);

  return {
    audio,
    recordingAudioDuration: duration,
    isRecording,
    recordAudio,
    stopRecording,
    clearRecording,
  };
};

export default useAudioRecorder;
